import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, className = "" }) => (
  <motion.div
    initial={{ opacity: 0, y: 24 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.6, delay, ease: [0.22, 1, 0.36, 1] }}
    className={className}
  >
    {children}
  </motion.div>
);

export const Eyebrow = ({ children, light = false }) => (
  <p className={`eyebrow ${light ? "!text-[#ff6a00]" : ""}`} data-testid="section-eyebrow">
    {children}
  </p>
);

export const PrimaryButton = ({ to, children, testid, className = "" }) => (
  <Link
    to={to}
    data-testid={testid}
    className={`inline-flex items-center justify-center gap-2 whitespace-nowrap bg-[#ff6a00] px-7 py-4 text-[13px] font-bold tracking-[0.12em] text-white shadow-[0_10px_24px_-10px_rgba(255,106,0,0.55)] transition-all duration-200 hover:-translate-y-0.5 hover:bg-[#e05d00] hover:shadow-[0_16px_32px_-10px_rgba(255,106,0,0.65)] active:translate-y-0 ${className}`}
  >
    {children}
  </Link>
);

export const GhostButton = ({ to, children, testid, dark = false, className = "" }) => (
  <Link
    to={to}
    data-testid={testid}
    className={`inline-flex items-center justify-center gap-2 whitespace-nowrap border px-7 py-4 text-[13px] font-bold tracking-[0.12em] transition-all duration-200 hover:-translate-y-0.5 ${
      dark
        ? "border-white/30 text-white hover:border-[#ff6a00] hover:text-[#ff6a00]"
        : "border-[#191c1e]/25 text-[#191c1e] hover:border-[#191c1e] hover:shadow-[0_12px_24px_-16px_rgba(25,28,30,0.4)]"
    } ${className}`}
  >
    {children}
  </Link>
);

export const ArrowLink = ({ to, children, testid, light = false }) => (
  <Link
    to={to}
    data-testid={testid}
    className={`group inline-flex items-center gap-2 text-[13px] font-bold tracking-[0.12em] transition-colors duration-200 ${
      light ? "text-white hover:text-[#ff6a00]" : "text-[#191c1e] hover:text-[#ff6a00]"
    }`}
  >
    {children}
    <ArrowRight className="h-4 w-4 text-[#ff6a00] transition-transform duration-200 group-hover:translate-x-1" aria-hidden="true" />
  </Link>
);
